import React from 'react';
import { Box, Typography } from '@mui/material';
import { theme } from '../../../constants/theme';
import { useThemeContext } from '../../../hook/useThemeManager';
import { FONT_ENUM } from '../../../types/global/fonts.types';
import { emptyState } from '../../../assets/animations';
import { SafeLottie } from '../../Lottie/SafeLottie';

interface IEmptySearchBlock {
    title?: string;
    subTitle?: string;
    animation?: any;
    animationStyle?: React.CSSProperties;
    mainHeaderStyle?: React.CSSProperties;
    subHeaderStyle?: React.CSSProperties;
    actionButton?: JSX.Element;
}
const EmptySearchBlock: React.FC<IEmptySearchBlock> = ({
    title = 'No Results Found',
    subTitle = '',
    animation = emptyState,
    animationStyle,
    mainHeaderStyle,
    subHeaderStyle,
    actionButton,
}) => {
    const { themeStyle } = useThemeContext();

    const lottieStyle = {
        height: 200,
        width: '100%',
        marginTop: 30,
        ...animationStyle,
    };

    return (
        <Box
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
            }}
            sx={{ gap: '25px' }}>
            <Box>
                <SafeLottie animationData={animation} loop style={lottieStyle} />
            </Box>
            <Box
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                }}
                sx={{ marginTop: -2.5, paddingBottom: 4 }}>
                <Typography
                    style={{
                        fontSize: 24,
                        fontWeight: '600',
                        fontFamily: FONT_ENUM.MAIN_MEDIUM,
                        textAlign: 'center',
                        color: theme[themeStyle].tag_white,
                        ...mainHeaderStyle,
                    }}>
                    {title}
                </Typography>
                <Typography
                    style={{
                        fontSize: 12,
                        fontWeight: '500',
                        fontFamily: FONT_ENUM.MAIN_MEDIUM,
                        textAlign: 'center',
                        color: theme[themeStyle].tag_white,
                        maxWidth: '344px',
                        ...subHeaderStyle,
                    }}>
                    {subTitle}
                </Typography>
            </Box>
            {actionButton && actionButton}
        </Box>
    );
};

export { EmptySearchBlock };
